export const logout = () => {
  // document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
  const form = document.createElement('form');
  form.method = 'POST';

  const pathName = window.location.pathname;

  if (pathName.startsWith('/event-order')) {
    form.action = `/Account/Logout?returnUrl=${encodeURIComponent('/')}`;
  } else {
    form.action = `/Account/Logout?returnUrl=${encodeURIComponent(pathName)}`;
  }

  document.body.appendChild(form);

  setTimeout(() => {
    form.submit();
  });
};
